/**
 * External Dependencies
 */
import { useCallback, useEffect, useState } from "react";
import axios from "axios";

/**
 * Internal dependencies:
 */
import route from "@/utils/route";
import { showToastMessage } from "@/frontend/modules/add-to-cart";

const DEFAULT_DISCOUNT = {
    code: "",
    name: null,
    discount: 0,
};

export const useDiscount = ({ onApply, storageApi } = {}) => {
    const [discount, setDiscount] = useState(DEFAULT_DISCOUNT);

    const updateDiscount = useCallback(
        async (overrideCode) => {
            const code = overrideCode?.length ? overrideCode : discount.code;

            try {
                const res = await axios.get(
                    route("discounts.show", {
                        discount_code: code,
                    }),
                );

                if (parseFloat(res.data?.discount)) {
                    showToastMessage(
                        3000,
                        `${res.data.name} discount applied to your cart.`,
                    );
                } else if (code?.length > 0) {
                    showToastMessage(3000, res.data);
                }

                await storageApi.setDiscountCode(res.data.code);

                if (typeof onApply == "function") {
                    await onApply(res.data);
                }

                setDiscount(res.data);
            } catch (error) { }
        },
        [discount, onApply],
    );

    const onDiscountInput = useCallback(
        (event) => {
            setDiscount((current) => {
                return { ...current, code: event.target.value };
            });
        },
        [setDiscount],
    );

    useEffect(() => {
        (async () => {
            const code = await storageApi.getDiscountCode();
            await updateDiscount(code);
        })();
    }, []);

    return {
        discount,
        onDiscountInput,
        updateDiscount,
    };
};
